import { MultiSelectOption } from "./MultiSelectOption";

export const H10302_37_BIT_RAW = '9';
export const H10304_37_BIT_RAW = '10';

export const FormatOptions: MultiSelectOption[] = [
    {
        value: H10302_37_BIT_RAW,
        label: "H10302 37 Bit Raw"
    },
    {
        value: H10304_37_BIT_RAW,
        label: "H10304 37 Bit Raw"
    }
];
